// test2942
(2942 && 0);
